// Slightly improved clock avoiding bugs (THREE.Clock was not working well in firefox)
export class AClock {
    constructor() {
        this.paused = false;
        this.dMS = 0.0;
        this.dS = 0.0;
        this.lastTime = (new Date().getTime());
    }
    update() {
        let currentTime = new Date().getTime();
        if (this.lastTime === 0.0) {
            this.lastTime = currentTime;
            return;
        }
        let delta = currentTime - this.lastTime;
        this.lastTime = currentTime;
        this.dMS += delta;
        this.dS = this.dMS / 1000;

    }
    pause() {
        this.pause = true;
    }
    resume() {
        this.paused = false;
        this.lastTime = new Date().getTime();
    }
    deltaTime() {
        return this.deltaTime;
    }
}
